import { render, staticRenderFns } from "./IkkatsuAnswerSheetUpload.vue?vue&type=template&id=4fc41776&"
import script from "./IkkatsuAnswerSheetUpload.vue?vue&type=script&lang=ts&"
export * from "./IkkatsuAnswerSheetUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports